import "intersection-observer";

import _ from 'lodash';

import Vue from 'vue'

import VueResource from 'vue-resource';
import VuePaginate from 'vue-paginate';
import VueLazyload from 'vue-lazyload';
import VeeValidate, { Validator } from 'vee-validate';
import validate_fr from 'vee-validate/dist/locale/fr';

import LazyLoad from 'vanilla-lazyload/dist/lazyload.min';

import Tabs from './components/Tabs.vue';
import Tab from './components/Tab.vue';
import DiscoverComponent from "./components/Discover.vue";
import UnitsComponent from "./components/Units.vue";
import FormComponent from "./components/Form.vue";
import NeighbourhoodComponent from "./components/Neighbourhood.vue";

import Header from './elements/header';
import Home from './elements/home';
import Popup from './elements/popup';
import Project from './elements/project';

Vue.use(VueResource);
Vue.use(VueLazyload);
Vue.use(VeeValidate);
Vue.use(VuePaginate);

if (globals.lang === "fr") {
	Validator.localize('fr', validate_fr);
}

function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
			var pair = vars[i].split("=");
			if(pair[0] == variable){return pair[1];}
	}
	return(false);
}
// Coming soon projects
var elementContent = document.getElementById("content");
var elementHeader = document.getElementById("header");
if (getQueryVariable("coming-soon") == "true") {
	elementContent.classList.add("project-coming-soon");
	elementHeader.classList.add("header-coming-soon");
}
// Register form
else if (getQueryVariable("register") == "true") {
	elementContent.classList.add("form-register-now");
	elementHeader.classList.add("header-register-now");
}
// Waiting list form
else if (getQueryVariable("waiting-list") == "true") {
	elementContent.classList.add("form-waiting-list");
	elementHeader.classList.add("header-waiting-list");
}
else {
	elementContent.classList.remove("project-coming-soon", "form-register-now", "form-waiting-list");
	elementHeader.classList.remove("header-coming-soon", "header-register-now", "header-waiting-list");
}
//

window.app = new Vue({
	el: '#app',
	components: {
		'tabs': Tabs,
		'tab': Tab,
		DiscoverComponent,
		UnitsComponent,
		FormComponent,
		NeighbourhoodComponent
	},
	methods: {
		tabChanged: function (data) {
			if (data.tab.$children.length > 0 && this.$refs["units"] && data.tab.$children[0]._uid === this.$refs["units"]._uid) {
				this.$refs["units"].refresh();
			}
			if (data.tab.$children.length > 0 && this.$refs["neighbourhood"] && data.tab.$children[0]._uid === this.$refs["neighbourhood"]._uid) {
				this.$refs["neighbourhood"].refresh();
			}
		}
	}
});

new LazyLoad({
	elements_selector: ".lazy",
	threshold: 10
});

new Header();
new Home();
new Popup();
new Project();
